import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  fr: {
    // Navigation
    'nav.home': 'Accueil',
    'nav.products': 'Produits',
    'nav.categories': 'Catégories',
    'nav.about': 'À propos',
    'nav.contact': 'Contact',
    'nav.login': 'Connexion',
    'nav.logout': 'Déconnexion',
    'nav.profile': 'Profil',
    'nav.orders': 'Commandes',
    'nav.wishlist': 'Liste de souhaits',
    'nav.admin': 'Administration',
    'nav.cart': 'Panier',

    // Hero Section
    'hero.title1': 'Bijoux Élégants',
    'hero.subtitle1': 'Découvrez notre collection unique avec des éléments iraniens',
    'hero.cta1': 'Voir les produits',
    'hero.title2': 'Artisanat Traditionnel',
    'hero.subtitle2': 'Chaque pièce raconte une histoire de tradition et d\'élégance',
    'hero.cta2': 'Explorer les catégories',
    'hero.title3': 'Qualité Exceptionnelle',
    'hero.subtitle3': 'Des matériaux précieux et un savoir-faire irréprochable',
    'hero.cta3': 'En savoir plus',

    // Home Page
    'home.categories.title': 'Nos Catégories',
    'home.categories.subtitle': 'Découvrez notre gamme complète de bijoux élégants',
    'home.featured.title': 'Produits en Vedette',
    'home.featured.subtitle': 'Nos pièces les plus populaires et appréciées',
    'home.featured.viewAll': 'Voir tous les produits',
    'home.about.title': 'Notre Histoire',
    'home.about.description': 'Mahja Bijoux combine l\'élégance française avec la richesse culturelle iranienne pour créer des pièces uniques qui racontent une histoire.',
    'home.about.feature1': 'Matériaux de qualité exceptionnelle',
    'home.about.feature2': 'Artisanat traditionnel iranien',
    'home.about.feature3': 'Design moderne et élégant',
    'home.about.learnMore': 'En savoir plus',
    'home.about.heritage': 'Héritage Culturel',
    'home.about.heritageDesc': 'Chaque pièce reflète la richesse de la culture persane et l\'élégance française.',

    // Product
    'product.addToCart': 'Ajouter au panier',
    'product.outOfStock': 'Rupture de stock',
    'product.inStock': 'En stock',
    'product.description': 'Description',
    'product.details': 'Détails',
    'product.material': 'Matière',
    'product.gemstone': 'Pierre précieuse',
    'product.weight': 'Poids',
    'product.dimensions': 'Longueur total',

    // Cart
    'cart.title': 'Votre Panier',
    'cart.empty': 'Votre panier est vide',
    'cart.subtotal': 'Sous-total',
    'cart.shipping': 'Livraison',
    'cart.total': 'Total',
    'cart.checkout': 'Commander',
    'cart.continueShopping': 'Continuer les achats',
    'cart.remove': 'Supprimer',
    'cart.update': 'Mettre à jour',

    // Auth
    'auth.login': 'Connexion',
    'auth.register': 'Inscription',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.confirmPassword': 'Confirmer le mot de passe',
    'auth.firstName': 'Prénom',
    'auth.lastName': 'Nom',
    'auth.phone': 'Téléphone',
    'auth.address': 'Adresse',
    'auth.city': 'Ville',
    'auth.postalCode': 'Code postal',
    'auth.country': 'Pays',
    'auth.forgotPassword': 'Mot de passe oublié ?',
    'auth.rememberMe': 'Se souvenir de moi',
    'auth.noAccount': 'Pas de compte ?',
    'auth.hasAccount': 'Déjà un compte ?',
    'auth.signUp': 'S\'inscrire',
    'auth.signIn': 'Se connecter',

    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.success': 'Succès',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.previous': 'Précédent',
    'common.search': 'Rechercher',
    'common.filter': 'Filtrer',
    'common.sort': 'Trier',
    'common.view': 'Voir',
    'common.close': 'Fermer',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.confirm': 'Confirmer',
    'common.details': 'Détails',
    'common.actions': 'Actions',
    'common.status': 'Statut',
    'common.date': 'Date',
    'common.price': 'Prix',
    'common.quantity': 'Quantité',
    'common.total': 'Total',
    'common.name': 'Nom',
    'common.description': 'Description',
    'common.image': 'Image',
    'common.category': 'Catégorie',
    'common.categories': 'Catégories',
    'common.products': 'Produits',
    'common.orders': 'Commandes',
    'common.users': 'Utilisateurs',
    'common.settings': 'Paramètres',
    'common.dashboard': 'Tableau de bord',
    'common.admin': 'Administration',
    'common.profile': 'Profil',
    'common.account': 'Compte',
    'common.logout': 'Déconnexion',
    'common.login': 'Connexion',
    'common.register': 'Inscription',
    'common.welcome': 'Bienvenue',
    'common.hello': 'Bonjour',
    'common.goodbye': 'Au revoir',
    'common.thankYou': 'Merci',
    'common.please': 'S\'il vous plaît',
    'common.optional': 'Optionnel',
    'common.required': 'Requis',
    'common.invalid': 'Invalide',
    'common.valid': 'Valide',
    'common.available': 'Disponible',
    'common.unavailable': 'Indisponible',
    'common.active': 'Actif',
    'common.inactive': 'Inactif',
    'common.pending': 'En attente',
    'common.approved': 'Approuvé',
    'common.rejected': 'Rejeté',
    'common.completed': 'Terminé',
    'common.cancelled': 'Annulé',
    'common.shipped': 'Expédié',
    'common.delivered': 'Livré',
    'common.processing': 'En cours',
    'common.confirmed': 'Confirmé',
    'common.paid': 'Payé',
    'common.unpaid': 'Non payé',
    'common.refunded': 'Remboursé',
    'common.failed': 'Échoué',
    'common.successful': 'Réussi',
    'common.unsuccessful': 'Échoué',
    'common.online': 'En ligne',
    'common.offline': 'Hors ligne',
    'common.visible': 'Visible',
    'common.hidden': 'Masqué',
    'common.public': 'Public',
    'common.private': 'Privé',
    'common.draft': 'Brouillon',
    'common.published': 'Publié',
    'common.unpublished': 'Non publié',
    'common.featured': 'En vedette',
    'common.normal': 'Normal',
    'common.premium': 'Premium',
    'common.basic': 'Basique',
    'common.advanced': 'Avancé',
    'common.simple': 'Simple',
    'common.complex': 'Complexe',
    'common.easy': 'Facile',
    'common.difficult': 'Difficile',
    'common.fast': 'Rapide',
    'common.slow': 'Lent',
    'common.high': 'Élevé',
    'common.low': 'Faible',
    'common.medium': 'Moyen',
    'common.large': 'Grand',
    'common.small': 'Petit',
    'common.big': 'Gros',
    'common.tiny': 'Minuscule',
    'common.huge': 'Énorme',
    'common.massive': 'Massif',
    'common.mini': 'Mini',
    'common.maxi': 'Maxi',
    'common.extra': 'Extra',
    'common.super': 'Super',
    'common.ultra': 'Ultra',
    'common.mega': 'Méga',
    'common.giga': 'Giga',
    'common.tera': 'Téra',
    'common.peta': 'Péta',
    'common.exa': 'Exa',
    'common.zetta': 'Zetta',
    'common.yotta': 'Yotta'
  },
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.products': 'Products',
    'nav.categories': 'Categories',
    'nav.about': 'About',
    'nav.contact': 'Contact',
    'nav.login': 'Login',
    'nav.logout': 'Logout',
    'nav.profile': 'Profile',
    'nav.orders': 'Orders',
    'nav.wishlist': 'Wishlist',
    'nav.admin': 'Admin',
    'nav.cart': 'Cart',

    // Hero Section
    'hero.title1': 'Elegant Jewelry',
    'hero.subtitle1': 'Discover our unique collection with Iranian elements',
    'hero.cta1': 'View Products',
    'hero.title2': 'Traditional Craftsmanship',
    'hero.subtitle2': 'Each piece tells a story of tradition and elegance',
    'hero.cta2': 'Explore Categories',
    'hero.title3': 'Exceptional Quality',
    'hero.subtitle3': 'Precious materials and impeccable craftsmanship',
    'hero.cta3': 'Learn More',

    // Home Page
    'home.categories.title': 'Our Categories',
    'home.categories.subtitle': 'Discover our complete range of elegant jewelry',
    'home.featured.title': 'Featured Products',
    'home.featured.subtitle': 'Our most popular and loved pieces',
    'home.featured.viewAll': 'View All Products',
    'home.about.title': 'Our Story',
    'home.about.description': 'Mahja Jewelry combines French elegance with Iranian cultural richness to create unique pieces that tell a story.',
    'home.about.feature1': 'Exceptional quality materials',
    'home.about.feature2': 'Traditional Iranian craftsmanship',
    'home.about.feature3': 'Modern and elegant design',
    'home.about.learnMore': 'Learn More',
    'home.about.heritage': 'Cultural Heritage',
    'home.about.heritageDesc': 'Each piece reflects the richness of Persian culture and French elegance.',

    // Product
    'product.addToCart': 'Add to Cart',
    'product.outOfStock': 'Out of Stock',
    'product.inStock': 'In Stock',
    'product.description': 'Description',
    'product.details': 'Details',
    'product.material': 'Material',
    'product.gemstone': 'Gemstone',
    'product.weight': 'Weight',
    'product.dimensions': 'Longueur total',

    // Cart
    'cart.title': 'Your Cart',
    'cart.empty': 'Your cart is empty',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.total': 'Total',
    'cart.checkout': 'Checkout',
    'cart.continueShopping': 'Continue Shopping',
    'cart.remove': 'Remove',
    'cart.update': 'Update',

    // Auth
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.confirmPassword': 'Confirm Password',
    'auth.firstName': 'First Name',
    'auth.lastName': 'Last Name',
    'auth.phone': 'Phone',
    'auth.address': 'Address',
    'auth.city': 'City',
    'auth.postalCode': 'Postal Code',
    'auth.country': 'Country',
    'auth.forgotPassword': 'Forgot Password?',
    'auth.rememberMe': 'Remember Me',
    'auth.noAccount': 'Don\'t have an account?',
    'auth.hasAccount': 'Already have an account?',
    'auth.signUp': 'Sign Up',
    'auth.signIn': 'Sign In',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.sort': 'Sort',
    'common.view': 'View',
    'common.close': 'Close',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.confirm': 'Confirm',
    'common.details': 'Details',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.price': 'Price',
    'common.quantity': 'Quantity',
    'common.total': 'Total',
    'common.name': 'Name',
    'common.description': 'Description',
    'common.image': 'Image',
    'common.category': 'Category',
    'common.categories': 'Categories',
    'common.products': 'Products',
    'common.orders': 'Orders',
    'common.users': 'Users',
    'common.settings': 'Settings',
    'common.dashboard': 'Dashboard',
    'common.admin': 'Admin',
    'common.profile': 'Profile',
    'common.account': 'Account',
    'common.logout': 'Logout',
    'common.login': 'Login',
    'common.register': 'Register',
    'common.welcome': 'Welcome',
    'common.hello': 'Hello',
    'common.goodbye': 'Goodbye',
    'common.thankYou': 'Thank You',
    'common.please': 'Please',
    'common.optional': 'Optional',
    'common.required': 'Required',
    'common.invalid': 'Invalid',
    'common.valid': 'Valid',
    'common.available': 'Available',
    'common.unavailable': 'Unavailable',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.pending': 'Pending',
    'common.approved': 'Approved',
    'common.rejected': 'Rejected',
    'common.completed': 'Completed',
    'common.cancelled': 'Cancelled',
    'common.shipped': 'Shipped',
    'common.delivered': 'Delivered',
    'common.processing': 'Processing',
    'common.confirmed': 'Confirmed',
    'common.paid': 'Paid',
    'common.unpaid': 'Unpaid',
    'common.refunded': 'Refunded',
    'common.failed': 'Failed',
    'common.successful': 'Successful',
    'common.unsuccessful': 'Unsuccessful',
    'common.online': 'Online',
    'common.offline': 'Offline',
    'common.visible': 'Visible',
    'common.hidden': 'Hidden',
    'common.public': 'Public',
    'common.private': 'Private',
    'common.draft': 'Draft',
    'common.published': 'Published',
    'common.unpublished': 'Unpublished',
    'common.featured': 'Featured',
    'common.normal': 'Normal',
    'common.premium': 'Premium',
    'common.basic': 'Basic',
    'common.advanced': 'Advanced',
    'common.simple': 'Simple',
    'common.complex': 'Complex',
    'common.easy': 'Easy',
    'common.difficult': 'Difficult',
    'common.fast': 'Fast',
    'common.slow': 'Slow',
    'common.high': 'High',
    'common.low': 'Low',
    'common.medium': 'Medium',
    'common.large': 'Large',
    'common.small': 'Small',
    'common.big': 'Big',
    'common.tiny': 'Tiny',
    'common.huge': 'Huge',
    'common.massive': 'Massive',
    'common.mini': 'Mini',
    'common.maxi': 'Maxi',
    'common.extra': 'Extra',
    'common.super': 'Super',
    'common.ultra': 'Ultra',
    'common.mega': 'Mega',
    'common.giga': 'Giga',
    'common.tera': 'Tera',
    'common.peta': 'Peta',
    'common.exa': 'Exa',
    'common.zetta': 'Zetta',
    'common.yotta': 'Yotta'
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get language from localStorage or default to French
    const savedLanguage = localStorage.getItem('language') || 'fr';
    setLanguage(savedLanguage);
    setLoading(false);
  }, []);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  const value = {
    language,
    changeLanguage,
    t,
    loading
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 